import type React from 'react';
import SvgIcon from './SvgIcon';

const ArrowLeft: React.FC = () => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="ArrowLeft">
      <path
        d="M12.2074 5.20654L6.41445 10.9995L20.0004 10.9995V12.9995L6.41445 12.9995L12.2074 18.7925L10.7934 20.2065L3.29336 12.7065C2.90288 12.316 2.90285 11.683 3.29336 11.2925L10.7934 3.79248L12.2074 5.20654Z"
        fill="#7B61FF"
        fillOpacity="0.9"
      />
    </g>
  </SvgIcon>
);

export default ArrowLeft;
